import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/shared/services/api.service';

import { environment } from '../../../../../../environments/environment';

declare var require: any
const FileSaver = require('file-saver');
@Component({
  selector: 'app-resources',
  templateUrl: './resources.component.html',
  styleUrls: ['./resources.component.scss']
})
export class ResourcesComponent implements OnInit {

  resourcesData:any=[]
    imgUrl=environment.apiUrls.imageUrl
    docsUrl=environment.apiUrls.pdfUrl
    constructor(private apiService:ApiService){}
    ngOnInit(){
        this.getResourceList()
    }
    
    getResourceList(){
        this.apiService.getResourceList(1,100).subscribe((res:any)=>{
           this.resourcesData=res?.items
        })
      }
      downloadPdf(data:any) {
        const pdfUrl = this.docsUrl +data;
        const pdfName = data;
        FileSaver.saveAs(pdfUrl, pdfName);
      }
}

